<div class="container">
  <input
    type="text"
    [ngStyle]="styleObject"
    placeholder="{{ placeholder }}"
    pattern="{{ pattern }}"
    value="{{ value }}"
    (change)="onChange($event)"
    (blur)="initStylesObject()"
    [attr.disabled]="disabled ? 'disabled' : null"
  />
</div>
